import React, {Component} from 'react';

export default class MonthlyBonus extends Component {
    constructor (props) {
        super(props)

        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        this.state = {
            monthNames: monthNames
        }
    }

    render() {
        let thisMonth = new Date().getMonth();
        let visibleMonths = [];
        let hiddenMonths = [];

        if(thisMonth > 4) {
            visibleMonths = this.state.monthNames.slice(thisMonth-3, thisMonth + 1);
            hiddenMonths = this.state.monthNames.slice(0, thisMonth - 3);
        }

        let hiddenMonthsLi = hiddenMonths.map((item, i) => {
            return (
                <li key={i}>{item}</li>
            )
        })

        let visibleMonthsLi = visibleMonths.map((item, i) => {
            switch (i) {
                case 0:
                    return(<li key={i} className="monthlyBonus_calendar_listOfMonths_firstMonth">{item}</li>)
                    break;
                case 1:
                    return(<li key={i} className="monthlyBonus_calendar_listOfMonths_secondMonth">{item}</li>)
                    break;
                case 2:
                    return(<li key={i} className="monthlyBonus_calendar_listOfMonths_thirdMonth">{item}</li>)
                    break;
                case 3:
                    return(<li key={i} >{item}</li>)
                    break;
            }
        })

        return(
            <div className="monthlyBonus">
                <div className="monthlyBonus_calendar">
                    <ul className="monthlyBonus_calendar_listOfMonths">
                        <li>...
                            <ul className="monthlyBonus_calendar_listOfMonths_hidden">
                                {hiddenMonthsLi}
                            </ul>
                        </li>
                        {visibleMonthsLi}
                        <li>All time</li>
                    </ul>
                </div>
                <div className="monthlyBonus_bonusAmount">
                    <p>Access to the monthly bonus</p>
                    <div className="monthlyBonus_bonusAmount_progressBar">
                        <p className="activity">129.6/2000 - my activity in september</p>
                        <p className="lastUpdate">5 days left</p>
                        <div className="info"></div>
                    </div>
                </div>
            </div>
        )
    }
}
